'use strict';

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _hfReactHelper = require('common/utils/hf-react-helper');

var _hfReactHelper2 = _interopRequireDefault(_hfReactHelper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var PeekABoo = _react2['default'].createClass({
    displayName: 'PeekABoo',


    propTypes: {
        imageUrl: _react2['default'].PropTypes.string,
        imageHeight: _react2['default'].PropTypes.number,
        imageWidth: _react2['default'].PropTypes.number
    },

    componentDidMount: function componentDidMount() {
        var offset = $('.m-peek-a-boo--parallax img').offset();
        if (offset) {
            var peekYPos = offset.top;
            var scrollBottom = $(window).scrollTop() + $(window).height();
            if (scrollBottom > peekYPos - 150) {
                $('.m-peek-a-boo--parallax img').addClass('is-visible');
            }
            $(window).scroll(function () {
                var scrollBottom = $(window).scrollTop() + $(window).height();
                if (scrollBottom > peekYPos - 150) {
                    $('.m-peek-a-boo--parallax img').addClass('is-visible');
                }
            });
        }
    },
    render: function render() {
        return _react2['default'].createElement(
            'div',
            { className: 'm-peek-a-boo ', 'data-equalizer-watch': true },
            _react2['default'].createElement(
                'div',
                { className: 'l-vertical-align m-peek-a-boo--parallax m-feature--outer-container' },
                _react2['default'].createElement('img', { className: 'm-peek-a-boo--image', 'data-speed': '.4', height: this.props.imageHeight, width: this.props.imageWidth, src: _hfReactHelper2['default'].imgHelper(this.props.imageUrl) })
            )
        );
    }
});
module.exports = PeekABoo;


/*****************
 ** WEBPACK FOOTER
 ** ./src/common/components/peekaboo.jsx
 ** module id = 707
 ** module chunks = 0
 **/